import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import * as Sentry from "@sentry/capacitor";
import * as SentryAngular from "@sentry/angular";

if (environment.production) {
    enableProdMode();
    console.log = () => {};
}

// Init sentry
Sentry.init({
        dsn: 'https://09450406c84d71d8bcb3835e5ba7b637@o4506439126810624.ingest.us.sentry.io/4510402078703616',
        enabled: environment.production,
        // Same string as package.json "version". scripts/sync-version.mjs
        // writes it into environment*.ts during semantic-release prepare.
        release: environment.version,
        dist: environment.buildNumber.toString(),
        integrations: [
            Sentry.browserTracingIntegration()
        ],
    },
    SentryAngular.init
);

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
